import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle,
} from '@angular/material/dialog';

export interface SuccessDialogData {
  successMessage: string;
}

@Component({
  selector: 'app-dialog-success-modal',
  standalone: true,
  imports: [MatDialogModule, MatDialogClose, MatButtonModule],
  templateUrl: './dialog-success-modal.component.html',
  styleUrl: './dialog-success-modal.component.scss',
})
export class DialogSuccessModalComponent implements OnInit {
  readonly data = inject<SuccessDialogData>(MAT_DIALOG_DATA);
  successMessage: string = 'This transaction has completed successfully';

  ngOnInit(): void {
    this.successMessage = this.data.successMessage;
  }
}
